<template>
    <v-card flat tile min-height="380" class="d-flex flex-column">
        <confirm ref="confirm"></confirm>
        <edit
            ref="editModal"
            v-show="showEdit"
            v-on:cancel="showEdit = false"
            v-on:requestReload="load"
        ></edit>
        <v-card-text
            v-if="!path"
            class="grow d-flex justify-center align-center grey--text"
        >Wähle eine Datei oder Ordner
        </v-card-text>
        <v-card-text
            v-else-if="isFile"
            class="grow d-flex justify-top align-top"
            @drop.prevent="onDrop($event, path)"
            @dragenter="toggleBackgroundColor"
            @dragleave="toggleBackgroundColor"
            @dragover.prevent
        >

            <v-list subheader v-if="files.length">
                <v-subheader>Dateien</v-subheader>
                <v-list-item
                    v-for="item in files"
                    :key="item.basename"
                    class="pl-0"
                >
                    <v-list-item-avatar class="ma-0">
                        <v-icon>{{ icons[item.extension.toLowerCase()] || icons['other'] }}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-2">
                        <v-list-item-title v-text="item.displayTitle" class="wrap-text">Tets</v-list-item-title>
                        <v-list-item-subtitle>{{ formatBytes(item.size) }} / {{ item.fileDate.toLocaleDateString() }}
                            {{ item.fileDate.toLocaleTimeString() }}
                        </v-list-item-subtitle>
                    </v-list-item-content>

                    <div class="d-flex flex-column">
                        <div class="d-flex flex-row">
                            <v-btn icon @click.stop="downloadItem(item)">
                                <v-icon color="">mdi-download</v-icon>
                            </v-btn>
                            <v-btn icon @click.stop="deleteItem(item)">
                                <v-icon color="red lighten-2">mdi-delete-outline</v-icon>
                            </v-btn>
                        </div>
                        <div class="d-flex flex-row">
                            <v-btn icon @click.stop="editFile(item)">
                                <v-icon color="green lighten-1">mdi-pencil-outline</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </v-list-item>
            </v-list>
        </v-card-text>

        <v-card-text v-else-if="dirs.length || files.length" class="grow">
            <v-list subheader v-if="dirs.length">
                <v-subheader>Ordner</v-subheader>
                <v-list-item
                    v-for="item in dirs"
                    :key="item.basename"
                    @click="changePath(item.path)"
                    class="pl-0"
                >
                    <v-list-item-avatar class="ma-0">
                        <v-icon>mdi-folder-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="py-2">
                        <v-list-item-title v-text="item.basename" class="wrap-text"></v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn icon @click.stop="deleteItem(item)">
                            <v-icon color="grey lighten-1">mdi-delete-outline</v-icon>
                        </v-btn>
                        <v-btn icon v-if="false">
                            <v-icon color="grey lighten-1">mdi-information</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            <v-divider v-if="files.length"></v-divider>
            <v-list subheader v-if="files.length">
                <v-subheader>Dateien</v-subheader>
                <v-list-item
                    v-for="item in files"
                    :key="item.basename"
                    @click="changePath(item.path)"
                    class="pl-0"
                >
                    <v-list-item-avatar class="ma-0">
                        <v-icon>{{ icons[item.extension.toLowerCase()] || icons['other'] }}</v-icon>
                    </v-list-item-avatar>

                    <v-list-item-content class="py-2">
                        <v-list-item-title v-text="item.basename" class="wrap-text"></v-list-item-title>
                        <v-list-item-subtitle>{{ formatBytes(item.size) }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                        <v-btn icon @click.stop="deleteItem(item)">
                            <v-icon color="grey lighten-1">mdi-delete-outline</v-icon>
                        </v-btn>
                        <v-btn icon v-if="false">
                            <v-icon color="">mdi-information</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card-text>
        <v-card-text
            v-else-if="filter"
            class="grow d-flex justify-center align-center grey--text py-5"
        >Keine Dateien gefunden
        </v-card-text>
        <v-card-text
            v-else
            class="grow d-flex justify-center align-center grey--text py-5"
        >Dieser Ordner ist leer
        </v-card-text>
        <v-divider v-if="path"></v-divider>
        <v-toolbar v-if="false && path && isFile" dense flat class="shrink">
            <v-btn icon>
                <v-icon>mdi-download</v-icon>
            </v-btn>
        </v-toolbar>
        <v-toolbar v-if="path && isDir" dense flat class="shrink">
            <v-btn icon v-if="false">
                <v-icon>mdi-eye-settings-outline</v-icon>
            </v-btn>
            <v-btn icon @click="load">
                <v-icon>mdi-refresh</v-icon>
            </v-btn>
        </v-toolbar>
    </v-card>
</template>

<script>
import {formatBytes} from "./util";
import Confirm from "./Confirm.vue";
import Edit from "./Edit";

export default {
    props: {
        icons: Object,
        storage: String,
        path: String,
        endpoints: Object,
        axios: Function,
        refreshPending: Boolean,
        student: Number,
        filter: String
    },
    components: {
        Edit,
        Confirm
    },
    data() {
        return {
            items: [],
            filter: "",
            showEdit: false
        };
    },
    computed: {
        dirs() {
            return this.items.filter(
                item =>
                    item.type === "dir" && item.basename.includes(this.filter)
            );
        },
        files() {
            return this.items.filter(
                item =>
                    item.type === "file" && item.basename.toLowerCase().includes(this.filter.toLowerCase())
            );
        },
        isDir() {
            return this.path[this.path.length - 1] === "/";
        },
        isFile() {
            return !this.isDir;
        }
    },
    methods: {
        formatBytes,
        changePath(path) {
            this.$emit("path-changed", path);
        },
        async load() {
            this.$emit("loading", true);
            // get files for path
            if (!this.isDir) {
                // "/api/student-files/{student_id}?directory={directory}&api_token=3yDrMg9GmY8dApiT"
                const directory = this.path.split('/')[2]

                let url = this.endpoints.listFiles.url
                    .replace(new RegExp("{student_id}", "g"), this.student)
                    .replace(new RegExp("{directory}", "g"), directory);

                let config = {
                    url,
                    method: "get",
                    charset: 'utf-8',
                    responseEncodig: 'utf-8'
                };

                let response = await this.axios.request(config);

                // set itmes
                this.items = response.data.data.files.map(item => {

                    return {
                        type: "file",
                        path: "/" + item.org_FileName,
                        size: item.org_FileSize,
                        basename: item.org_FileName,
                        newName: item.new_FileName,
                        extension: item.org_FileType.replace('.', ''),
                        name: item.URL,
                        fileDate: new Date(item.org_FileDate),
                        copied_from: item.copied_from,
                        displayTitle: item.copied_from ? item.org_FileName + " (Kopie von " + item.copied_from + ")" : item.org_FileName,
                        // children: []
                    }
                })
            }
            this.$emit("loading", false);
        },
        async deleteItem(item) {
            let confirmed = await this.$refs.confirm.open(
                "Löschen",
                `Möchtest du diese Datei wirklich löschen <em>${item.basename}</em>?`
            );

            if (confirmed) {
                this.$emit("loading", true);
                // ?api_token=3yDrMg9GmY8dApiT
                let url = this.endpoints.delete.url
                    .replace(new RegExp("{storage}", "g"), this.storage)
                    .replace(new RegExp("{path}", "g"), item.newName);

                let config = {
                    url,
                    method: "DELETE"
                };

                await this.axios.request(config);
                this.$emit("file-deleted");
                this.$emit("loading", false);
            }
        },

        async downloadItem(item) {
            let url = this.endpoints.download.url
                .replace(new RegExp("{name}", "g"), item.newName)

            window.open(url, '_blank').focus();
        },

        editFile(item) {
            this.$refs.editModal.open(item.newName, this.student, this.endpoints)
            this.showEdit = true;
        },

        onDrop(e) {
            this.toggleBackgroundColor(e)

            this.$emit("add-files", e.dataTransfer.files);
        },

        toggleBackgroundColor(e) {
            e.currentTarget.parentElement.classList.toggle('upload-drop-area');
            let list = e.currentTarget.children[0]
            if (list) {
                list.classList.toggle('upload-drop-area');
                let items = list.children
                for (const element of items) {
                    element.classList.toggle('upload-drop-area');
                }
            }
        },
    },
    watch: {
        async path() {
            this.items = [];
            await this.load();
        },
        async refreshPending() {
            if (this.refreshPending) {
                await this.load();
                this.$emit("refreshed");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.v-card {
    height: 100%;
}

.wrap-text {
    white-space: break-spaces;
    word-break: break-word;
}

.upload-drop-area {
    background-color: #90caf9 !important;
}
</style>
